import { computed, } from 'vue';

const ID_PERMISSION_KEY = 'permissions' as string;

/**
 * Permissions Mapping Helper Object
 */
export const PERMISSIONS = {

  REPORT_ADMIN_V1_SALES_PAST_YEARS_VIEW: 'report.admin.v1.sales.past-years.view'
};

export const usePermissions = () => {
  const permissions = computed<string[]>(() => {
    try {
      const stored = window.localStorage.getItem(ID_PERMISSION_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error parsing permissions:', error);
      return [];
    }
  });

  const hasPermission = (payload: string | string[]): boolean => {
    if (Array.isArray(payload)) {
      return payload.some(permission =>
        permissions.value.includes(permission)
      );
    }

    return permissions.value.includes(payload);
  };

  const hasAllPermissions = (payload: string[]): boolean => {
    return payload.every(permission =>
      permissions.value.includes(permission)
    );
  };

  return {
    hasPermission,
    hasAllPermissions,
  };
};
